import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import CardMaisFiltros from './CardMaisFiltros.vue';
import { ConsultaJurisprudenciaSelecionadaStore } from '../../store/ConsultaJurisprudenciaSelecionadaStore';
import CustomChip from '@/views/components/CustomChip.vue';
import { OPERADORES } from '@/constants/operadores';
import { useRoute } from 'vue-router/composables';
import { GET_CARTORIOS } from '@/queries';
import { useLazyQuery } from '@vue/apollo-composable';
import SdsSnackbarQueue from '@ungp/sds-snackbar-queue';
import { useLoader } from '@/composables/useLoader';
import { getISOFromDate } from '@/utils/DateUtils';

interface IOperador {
  operador: string;
  tooltip: string;
  value: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardParametrosConsulta',
  setup(__props) {

const store = ConsultaJurisprudenciaSelecionadaStore();

const { filtroJurisprudencia, pagina } = storeToRefs(store);
const { consultaJurisprudenciaSelecionada, limparTodosFiltroJurisprudencia } =
  store;

const loader = useLoader();

const { query } = useRoute();

const getSecao = useLazyQuery(GET_CARTORIOS);

onMounted(async () => {
  const dtJulgamentoInicio = getISOFromDate(String(query.dtJulgamentoini));
  const dtJulgamentoFim = getISOFromDate(String(query.dtJulgamentofim));
  const expandirPesquisaAvancada = Boolean(Object.keys(query).length);

  filtroJurisprudencia.value.dtJulgamentoInicio = dtJulgamentoInicio;
  filtroJurisprudencia.value.dtJulgamentoFim = dtJulgamentoFim;
  filtroJurisprudencia.value.expandirPesquisaAvancada =
    expandirPesquisaAvancada;

  await buscarSecao();
});

const buscarSecao = async () => {
  const deTipoCartorio = `${query.secao}`.replace(/^"(.*)"$/, '$1');
  getSecao.variables.value = { deTipoCartorio };

  if (!getSecao.variables.value) return;
  try {
    loader.startLoader();
    await getSecao.load();
    filtroJurisprudencia.value = {
      ...filtroJurisprudencia.value,
      secao: getSecao.result.value?.tipoCartorios ?? null,
    };
  } catch {
    SdsSnackbarQueue.error(
      getSecao.error.value?.message ?? 'Não foi possível pesquisar os boletins'
    );
  } finally {
    loader.dismissLoader();
  }
};

const handleClickTermos = (termo: IOperador) => {
  let dePesquisa = filtroJurisprudencia.value.dePesquisaTermos;

  const { operador } = termo;

  switch (operador) {
    case 'Aspas':
      dePesquisa = dePesquisa ? '"' + dePesquisa + '"' : '""';
      break;
    case 'Interrogacao':
      dePesquisa = dePesquisa ? dePesquisa + '?' : '?';
      break;
    case 'Asterisco':
      dePesquisa = dePesquisa ? dePesquisa + '*' : '*';
      break;
    default:
      dePesquisa = dePesquisa ? `${dePesquisa} ${operador} ` : operador;
  }

  filtroJurisprudencia.value = {
    ...filtroJurisprudencia.value,
    dePesquisaTermos: dePesquisa,
  };
};

const consultar = () => {
  pagina.value = 1;
  consultaJurisprudenciaSelecionada(true);
};

const limpar = () => {
  filtroJurisprudencia.value.expandirPesquisaAvancada = false;
  limparTodosFiltroJurisprudencia();
};

return { __sfc: true,store, filtroJurisprudencia, pagina, consultaJurisprudenciaSelecionada, limparTodosFiltroJurisprudencia, loader, query, getSecao, buscarSecao, handleClickTermos, consultar, limpar, CardMaisFiltros, CustomChip, OPERADORES }
}

})